import React from 'react';
import { EnvelopeIcon, PhoneIcon, UserCircleIcon } from '@heroicons/react/24/outline';
import { calculateAge } from '../../../utils/utils';
import { formatCustomerDate, formatCustomerValue } from './customerSubscriptionUtils';

const CustomerPersonalInfo = ({ customer }) => {
    const name = customer?.name || "-";
    const profilePicture = customer?.profile_picture || customer?.photo;
    const details = [
        { label: "SSO ID", value: formatCustomerValue(customer?.sso_id) },
        { label: "SSO Code", value: formatCustomerValue(customer?.sso_code) },
        { label: "Member Since", value: formatCustomerDate(customer?.member_since, true) },
        { label: "Registration Device", value: formatCustomerValue(customer?.registration_device) },
        { label: "Gender", value: formatCustomerValue(customer?.gender) },
        // { label: "Age", value: customer?.age ?? calculateAge(customer?.date_of_birth) },
        { label: "Date of Birth", value: formatCustomerDate(customer?.date_of_birth) },
        // { label: "Product", value: formatCustomerValue(customer?.product) },
    ];

    return (
        <div className="h-full overflow-hidden rounded-xl bg-white shadow-sm ring-1 ring-gray-100">
            <div className="flex flex-col items-center bg-gradient-to-br from-blue-50 to-indigo-50 px-6 py-6 text-center">
                {profilePicture ? (
                    <img src={profilePicture} alt={name} className="h-14 w-14 rounded-full object-cover" />
                ) : (
                    <UserCircleIcon className="h-14 w-14 text-indigo-300" />
                )}
                <h2 className="mt-3 text-md font-bold text-gray-900">{name}</h2>
                <p className="mt-1 rounded-full bg-white px-3 py-1 text-xs font-medium text-indigo-700 shadow-sm">
                    {customer?.sso_code || customer?.sso_id || "-"}
                </p>
            </div>

            <div className="space-y-3 border-b border-gray-100 px-6 py-4">
                <div className="flex items-center gap-2 text-sm text-gray-700">
                    <EnvelopeIcon className="h-4 w-4 shrink-0 text-gray-400" />
                    <span className="truncate">{customer?.email || "-"}</span>
                </div>
                <div className="flex items-center gap-2 text-sm text-gray-700">
                    <PhoneIcon className="h-4 w-4 shrink-0 text-gray-400" />
                    <span>{customer?.mobile_no || "-"}</span>
                </div>
            </div>

            <div className="grid grid-cols-2 gap-x-2 gap-y-2 px-6 py-5">
                {details.map((item) => (
                    <div key={item.label}>
                        <p className="text-xs font-medium tracking-wide text-gray-400">{item.label}</p>
                        <p className="mt-1 break-words text-xs font-semibold text-gray-800 capitalize">{item.value}</p>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default CustomerPersonalInfo;
